import React from 'react';
import { TrendingUpIcon, GraduationCapIcon, AwardIcon, UsersIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Careers = () => {
  return <div className="w-full" data-id="element-207">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-208">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-209"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-210">
          <h1 className="text-white font-bold mb-4" data-id="element-211">Join Our Team</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-212">
            Build a rewarding career helping others achieve financial freedom.
          </p>
        </div>
      </section>
      {/* Why Join Magnavera */}
      <section className="py-16" data-id="element-213">
        <div className="container mx-auto px-4" data-id="element-214">
          <div className="max-w-3xl mx-auto" data-id="element-215">
            <div className="text-center mb-12" data-id="element-216">
              <span className="inline-block text-primary font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-217">
                Why Join Magnavera
              </span>
              <h2 className="font-bold mb-4" data-id="element-218">Build a Meaningful Career</h2>
              <div className="w-20 h-1 bg-primary mx-auto mb-6" data-id="element-219"></div>
              <p className="text-text-secondary text-lg leading-relaxed" data-id="element-220">
                As a financial representative with Great Eastern, you're
                equipped with the knowledge to help people realise their goals
                and aspirations while also fulfilling your own with the range of
                opportunities we offer. From a comprehensive training roadmap to
                excellent digital tools, you'll have everything you need to
                reach for great.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg mb-10" data-id="element-221">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-222">
                <div data-id="element-223">
                  <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Financial Advisors Team" className="rounded-lg shadow-md w-full h-full object-cover" data-id="element-224" />
                </div>
                <div className="space-y-4" data-id="element-225">
                  <h3 className="font-bold text-xl mb-4" data-id="element-226">What We Offer</h3>
                  {['Comprehensive training and development', 'Mentorship from industry leaders', 'Unlimited earning potential', 'Work-life flexibility', 'Recognition and rewards', 'Career advancement opportunities'].map((item, index) => <div key={index} className="flex items-start" data-id="element-227">
                      <div className="bg-primary/10 p-1 rounded-full text-primary mr-3 mt-1" data-id="element-228">
                        <CheckCircleIcon size={18} data-id="element-229" />
                      </div>
                      <span data-id="element-230">{item}</span>
                    </div>)}
                </div>
              </div>
            </div>
            <div className="text-center mb-6" data-id="element-231">
              <Button href="https://www.greateasternlife.com/sg/en/careers/financial-representative/apply-now.html" target="_blank" rel="noopener noreferrer" className="px-8 py-4" data-id="element-232">
                Apply Now
                <ArrowRightIcon size={16} className="ml-2" data-id="element-233" />
              </Button>
            </div>
            <p className="text-center text-sm text-text-secondary" data-id="element-234">
              Take the first step towards a rewarding career in financial
              advisory.
            </p>
          </div>
        </div>
      </section>
      {/* Benefits */}
      <section className="py-16 bg-background" data-id="element-235">
        <div className="container mx-auto px-4" data-id="element-236">
          <div className="text-center mb-12" data-id="element-237">
            <h2 className="font-bold mb-4" data-id="element-238">Benefits of Joining Our Team</h2>
            <div className="w-20 h-1 bg-primary mx-auto" data-id="element-239"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-240">
            {[{
            icon: <TrendingUpIcon size={32} className="text-primary" data-id="element-241" />,
            title: 'Unlimited Growth',
            description: 'No ceiling on your income potential or career advancement opportunities.'
          }, {
            icon: <GraduationCapIcon size={32} className="text-primary" data-id="element-242" />,
            title: 'Continuous Learning',
            description: 'Access to industry-leading training programs and professional development.'
          }, {
            icon: <AwardIcon size={32} className="text-primary" data-id="element-243" />,
            title: 'Recognition & Rewards',
            description: 'Achievement recognition, incentive trips, and performance bonuses.'
          }, {
            icon: '<UsersIcon size={32} className="text-primary"/>',
            title: 'Supportive Community',
            description: "Join a team that celebrates success and supports each other's growth."
          }].map((benefit, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-card text-center" data-id="element-244">
                <div className="bg-primary/10 p-4 rounded-full inline-block mb-4" data-id="element-245">
                  {benefit.icon}
                </div>
                <h3 className="font-bold mb-2" data-id="element-246">{benefit.title}</h3>
                <p className="text-text-secondary" data-id="element-247">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16" data-id="element-248">
        <div className="container mx-auto px-4" data-id="element-249">
          <div className="text-center mb-12" data-id="element-250">
            <h2 className="font-bold mb-4" data-id="element-251">What Our Team Members Say</h2>
            <div className="w-20 h-1 bg-primary mx-auto" data-id="element-252"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-253">
            {[{
            quote: "Joining Magnavera Group was the best career decision I've made. The training, mentorship, and supportive environment have helped me grow both professionally and personally.",
            name: 'Sarah Chen',
            role: 'Financial Advisor, 5 years with Magnavera',
            image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }, {
            quote: 'What I appreciate most about being part of this team is the culture of excellence and the emphasis on continuous learning. Every day brings new opportunities to grow.',
            name: 'Michael Tan',
            role: 'Senior Financial Consultant, 8 years with Magnavera',
            image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80'
          }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-lg border border-gray-100" data-id="element-254">
                <p className="italic mb-6 text-text-secondary leading-relaxed" data-id="element-255">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center" data-id="element-256">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-257" />
                  <div data-id="element-258">
                    <p className="font-bold" data-id="element-259">{testimonial.name}</p>
                    <p className="text-text-secondary text-sm" data-id="element-260">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* FAQ Preview */}
      <section className="py-16 bg-background" data-id="element-261">
        <div className="container mx-auto px-4 text-center" data-id="element-262">
          <h2 className="font-bold mb-6" data-id="element-263">
            Have Questions About a Career With Us?
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto mb-8" data-id="element-264">
            Check out our frequently asked questions to learn more about what
            it's like to be a Financial Representative.
          </p>
          <Button href="/faq" variant="secondary" className="group" data-id="element-265">
            View Career FAQs
            <ArrowRightIcon size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" data-id="element-266" />
          </Button>
        </div>
      </section>
      {/* CTA Banner */}
      <section className="bg-primary py-16" data-id="element-267">
        <div className="container mx-auto px-4 text-center" data-id="element-268">
          <h2 className="text-white font-bold mb-4" data-id="element-269">
            Ready to Start Your Journey?
          </h2>
          <p className="text-white opacity-90 max-w-2xl mx-auto mb-8" data-id="element-270">
            Take the first step towards a rewarding career helping others
            achieve financial freedom.
          </p>
          <Button href="https://www.greateasternlife.com/sg/en/careers/financial-representative/apply-now.html" target="_blank" rel="noopener noreferrer" variant="secondary" className="bg-white text-primary" data-id="element-271">
            Apply Now
          </Button>
        </div>
      </section>
    </div>;
};
export default Careers;